/* Kukkiri — leva direto ao checkout, sem passar pelo carrinho.
   Duas camadas, porque o app de bundle pode enviar de dois jeitos:
   1) envio normal do formulário  -> o campo return_to resolve
   2) envio por AJAX (fetch/XHR)  -> aí o return_to é ignorado e precisamos redirecionar na mão */
(function () {
  'use strict';
  var DESTINO = '/checkout';

  // 1) todo formulário de compra leva o return_to
  function marcarFormularios() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (f.querySelector('input[name="return_to"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'return_to'; i.value = DESTINO;
      f.appendChild(i);
    });
  }

  // 2) se o app adicionar por AJAX, o navegador fica na página: redirecionamos nós
  var original = window.fetch;
  if (original) {
    window.fetch = function (recurso, opcoes) {
      var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url) || '';
      var ehAdd = url.indexOf('/cart/add') !== -1;
      return original.apply(this, arguments).then(function (resposta) {
        if (ehAdd && resposta && resposta.ok) {
          setTimeout(function () { window.location.href = DESTINO; }, 120);
        }
        return resposta;
      });
    };
  }
  var abrir = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this.__ehAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return abrir.apply(this, arguments);
  };
  var enviar = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__ehAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(function () { window.location.href = DESTINO; }, 120);
        }
      });
    }
    return enviar.apply(this, arguments);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', marcarFormularios)
    : marcarFormularios();
  document.addEventListener('shopify:section:load', marcarFormularios);
  setTimeout(marcarFormularios, 2000);   // o app desenha depois; reforça
})();
